import { useAdminMetrics } from '../lib/queries.js';

function brl(cents: number) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
}

function usd(s: string) {
  const n = Number(s);
  return Number.isFinite(n) ? n.toFixed(2) : s;
}

export function Dashboard() {
  const { data, isLoading, error } = useAdminMetrics();

  if (isLoading) return <div className="text-zinc-500">carregando…</div>;
  if (error || !data) return <div className="text-rose-400">erro ao carregar métricas</div>;

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        <Stat label="MRR" value={brl(data.mrr_cents)} />
        <Stat label="ARR" value={brl(data.arr_cents)} />
        <Stat label="Assinaturas ativas" value={data.active_subscriptions} />
        <Stat label="Canceladas" value={data.canceled_subscriptions} />
        <Stat label="Usuários totais" value={data.users.total} />
        <Stat label="Novos (30d)" value={data.users.new_30d} />
        <Stat label="Ativos (30d)" value={data.users.active_30d} />
        <Stat label="Workspaces" value={data.workspaces_total} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
        <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4">
          <div className="text-xs text-zinc-500 uppercase mb-2">IA · mês corrente</div>
          <div className="text-2xl font-semibold mb-2">${usd(data.ai.month_cost_usd)}</div>
          <div className="text-sm text-zinc-400">
            {data.ai.requests} requests · {data.ai.tokens_in.toLocaleString()} tokens in /{' '}
            {data.ai.tokens_out.toLocaleString()} out
          </div>
          <div className="text-xs text-zinc-500 mt-2">
            últimas 24h: ${usd(data.ai.day_cost_usd)}
          </div>
        </div>
        <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4">
          <div className="text-xs text-zinc-500 uppercase mb-2">Receita · mês corrente</div>
          <div className="text-2xl font-semibold mb-2">{brl(data.payments.revenue_brl_cents)}</div>
          <div className="text-sm text-zinc-400">
            ✓ {data.payments.approved} aprovados · ✗ {data.payments.rejected} rejeitados
          </div>
        </div>
      </div>

      <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4">
        <div className="text-xs text-zinc-500 uppercase mb-3">Top modelos (mês)</div>
        <table className="w-full text-sm">
          <thead className="text-zinc-500 text-xs uppercase border-b border-zinc-800">
            <tr>
              <th className="text-left py-2">Provider</th>
              <th className="text-left">Model</th>
              <th className="text-right">Custo USD</th>
            </tr>
          </thead>
          <tbody>
            {data.ai.top_models.map((m, i) => (
              <tr key={i} className="border-b border-zinc-800/50">
                <td className="py-2">{m.provider}</td>
                <td>{m.model}</td>
                <td className="text-right font-mono">${usd(m.cost)}</td>
              </tr>
            ))}
            {data.ai.top_models.length === 0 && (
              <tr>
                <td colSpan={3} className="py-3 text-center text-zinc-500">
                  sem uso ainda
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value }: { label: string; value: number | string }) {
  return (
    <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-4">
      <div className="text-xs text-zinc-500 uppercase">{label}</div>
      <div className="text-2xl font-semibold mt-1">{value}</div>
    </div>
  );
}
